import React, { Component } from 'react';
import radium from 'radium';
import $j from 'jquery';
import { ExternalScriptsEnum } from 'appConsts/ExternalScriptsEnum';
import { withExternalScript } from 'components/ScriptLoader';
import { user } from 'helper/currentUser';
import { NarrationStateEnum } from 'appConsts/narrationStateEnum';

let narrationState = {};
// const user = new CurrentUser();

const styles = getStyles(); // eslint-disable-line no-use-before-define
const myOptions = {
  nativeControlsForTouch: false,
  controls: true,
  autoplay: false,
  width: 'auto',
  height: 'auto',
  logo: { enabled: false },
  hotKeys: {
    seekStep: 10,
    enableJogStyle: false,
    volumeStep: 0.2,
    enableVolumeScroll: false
  } /* ,
  plugins: {
    playbackrate: {}
  } */
};

@withExternalScript({
  src: ExternalScriptsEnum.AzureMediaPlayer.src,
  id: ExternalScriptsEnum.AzureMediaPlayer.id
})
class AzureVideoPlayer extends Component {
  componentDidMount() {
    this.createOrChangeVideoSrc(
      this.props.videoUrl,
      this.props.thumbUrl,
      this.props.azureVideoOptions
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.videoUrl !== this.props.videoUrl) {
      this.createOrChangeVideoSrc(
        this.props.videoUrl,
        this.props.thumbUrl,
        this.props.azureVideoOptions
      );
    }
  }

  componentWillUnmount() {
    this.destroyAMP();
  }

  getAndSetPreviousTimeOfvideo = userId => {
    const mediaDurations = JSON.parse(localStorage.getItem(`${userId}_mediaDuration`));
    if (mediaDurations) {
      narrationState = {
        ...mediaDurations
      };
      const previousDuration = mediaDurations[this.props.uniqueId];
      if (previousDuration) {
        return previousDuration;
      }
    }
    return 0;
  };

  destroyAMP = () => {
    this.videoPlayerRef && this.videoPlayerRef.dispose();
    this.detachVideoEvents(this.videoPlayerRef);
    // this.videoPlayerRef && $j(this.videoPlayerRef.tag).off('ended.vp');
    this.videoPlayerRef = null;
  };

  setSrc = (videoPlayerRef, newSrc, newThumbImage) => {
    videoPlayerRef && videoPlayerRef.pause();
    if (newSrc.includes('.mp4')) {
      videoPlayerRef.src({ type: 'video/mp4', src: newSrc });
    } else if (newSrc.includes('/manifest')) {
      videoPlayerRef.src({ type: 'application/vnd.ms-sstr+xml', src: newSrc });
    } else if (newSrc.includes('.mov')) {
      videoPlayerRef.src({ type: 'video/mp4', src: newSrc });
    }
    newThumbImage && videoPlayerRef.poster(newThumbImage);
    // videoPlayerRef.autoplay(true);
    // console.log('videoPlayerRef::', videoPlayerRef.height('auto'));

    const userId = user.id();
    videoPlayerRef.addEventListener('timeupdate', () => {
      if (videoPlayerRef.currentTime() > 0) {
        narrationState[this.props.uniqueId] = videoPlayerRef.currentTime();
      }
      if (!this.props.preview && !this.props.editable) {
        localStorage.setItem(userId + '_mediaDuration', JSON.stringify(narrationState));
      }
    });

    videoPlayerRef.addEventListener('loadeddata', () => {
      const previousEndTime = this.getAndSetPreviousTimeOfvideo(userId);
      const shouldSetTime =
        this.props.completionStatus && this.props.completionStatus !== 'NOT_ATTEMPTED';
      if (shouldSetTime) {
        videoPlayerRef.currentTime(previousEndTime - NarrationStateEnum.mediaBufferState);
      } else {
        narrationState[this.props.uniqueId] = 0;
        localStorage.setItem(userId + '_mediaDuration', JSON.stringify(narrationState));
      }
    });
  };

  createOrChangeVideoSrc = (newSrc, newThumbImage, options) => {
    // console.log('this.videoPlayerRef::', this.videoPlayerRef);
    if (!this.videoPlayerRef) {
      const self = this;
      this.videoPlayerRef = window
        .amp(this.refs.videoPlayer, Object.assign({}, myOptions, options))
        .ready(function() {
          self.setSrc(this, newSrc, newThumbImage);
          self.attachVideoEvents(this);
        });
      return true;
    }
    this.setSrc(this.videoPlayerRef, newSrc, newThumbImage);
    this.attachVideoEvents(this.videoPlayerRef);
    return true;
  };

  isFullScreen = () => this.videoPlayerRef && this.videoPlayerRef.isFullScreen();

  attachVideoEvents = videoPlayerRef => {
    this.props.onEndEvent &&
      $j(videoPlayerRef.tag)
        .off('ended.vp')
        .on('ended.vp', this.props.onEndEvent);
  };

  detachVideoEvents = videoPlayerRef => {
    $j(videoPlayerRef.tag).off('ended.vp');
  };

  render() {
    return (
      <div style={styles.container}>
        <div className="azureVideoContainer" style={styles.container} tabIndex="1">
          <video
            id={this.props.uniqueId || 'video_id'}
            style={styles.videoStyle}
            ref="videoPlayer"
            className="azuremediaplayer amp-default-skin amp-big-play-centered"
            controls={true}
          >
            Your browser does not support HTML5 video.
          </video>
        </div>
      </div>
    );
  }
}

function getStyles() {
  return {
    classBased: {},
    container: {
      width: '100%'
    }
  };
}

export default radium(AzureVideoPlayer);
